import React from "react";
import { Box, Flex } from "theme-ui";

import { useAppSelector } from "store/hooks";
import { getCartTotalAmount } from "store/productPayment/selectors";
import { getCartTotalCount } from "store/productPayment/cart";

function PaymentInfo() {
  const totalAmount = useAppSelector(getCartTotalAmount);
  const totalCount = useAppSelector(getCartTotalCount);

  return (
    <Box
      sx={{
        backgroundColor: "primaryDark",
        borderRadius: "10px",
        color: "#fff",
        height: "91px",
        margin: "15px 0",
        padding: "15px 20px",
      }}
    >
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "20px" }}>결제금액</Box>
        <Box sx={{ fontSize: "20px" }}>{totalAmount.toLocaleString()} 원</Box>
      </Flex>
      <Flex
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: "5px 0",
        }}
      >
        <Box sx={{ fontSize: "14px" }}>수량</Box>
        <Box sx={{ fontSize: "14px" }}>{totalCount.toLocaleString()}개</Box>
      </Flex>
    </Box>
  );
}

export default PaymentInfo;
